import React, { useState, useRef, useCallback } from "react";
import { Box, Typography, Avatar, Popover } from "@mui/material";
import Video from "./Video";
import user_D from "../../../assets/customerAssets/user_D.jpeg";
import shareIcon from "../../../assets/customerAssets/icons/share.svg";
import moment from "moment/moment";
import VoteComponent from "./VoteComponent";
import ComentBox from "./ComentBox";
import ComentBoxClub from "../common/ComentBoxNew";
import TittleComponent from "./TittleComponent";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
  ThreadsShareButton,
  ThreadsIcon,
} from "react-share";
import InstagramWebShare from "../common/share/Instashare";
import GlobalPlayer from "../../GlobalVideoComponent/Index";
import ShareComponent from "../common/share/Index";
import { useSelector } from "react-redux";

const GoalComponent = ({ data }) => {
  const loggedUser = useSelector((state) => state.loggedUser.user);

  const formatRelativeDate = useCallback((dateString) => {
    const now = moment();
    const date = moment(dateString);

    // If same day → "Today, 3:45 PM"
    if (now.isSame(date, "day")) {
      return `Today, ${date.format("h:mm A")}`;
    }

    // If yesterday → "Yesterday"
    if (now.diff(date, "days") === 0) {
      // return `Yesterday ${now.diff(date, "hours")} hours ago`;
      return `${now.diff(date, "hours")} hours ago`;
    }

    const diffDays = now.diff(date, "days");
    const diffWeeks = now.diff(date, "weeks");
    const diffMonths = now.diff(date, "months");
    const diffYears = now.diff(date, "years");

    if (diffDays < 7) {
      return diffDays === 1 ? "1 day ago" : `${diffDays} days ago`;
    }

    if (diffWeeks < 5) {
      return diffWeeks === 1 ? "1 week ago" : `${diffWeeks} weeks ago`;
    }

    if (diffMonths < 12) {
      return diffMonths === 1 ? "1 month ago" : `${diffMonths} months ago`;
    }

    return diffYears === 1 ? "1 year ago" : `${diffYears} years ago`;
  }, []);
  // "";
  const [showMoreTitle, setShowMoreTitle] = useState(false);
  const [sharePop, setSharePop] = useState(null);

  const shareOpen = Boolean(sharePop);

  const shareUrl = useRef(window.location.href);
  // "";

  return (
    <>
      <Box className="goal-wrapper">
        <Box className="video-wrapper">
          <Box className="user-wrapper">
            <Box className="user">
              <Avatar
                alt="Remy Sharp"
                src={
                  data?.club_img || data?.goalUserDetails?.profile_img || user_D
                }
                sx={{ width: 48, height: 48 }}
              />
              <Box className="content">
                <Typography component="span">
                  {!data.isTournament
                    ? `Goal scorer: ${data?.goal_scorer}`
                    : `Tournament: ${data?.tournamentDetails?.title}`}
                </Typography>
                <Typography component="p">
                  {formatRelativeDate(data?.createdAt)}
                </Typography>
              </Box>
            </Box>
          </Box>
          <GlobalPlayer link={data?.video_link} thumbnail={data?.thumbnail} />
        </Box>
        <Box className="content-wrapper">
          <Box className="content">
            <Box className="icons">
              <Box className="vote i">
                <VoteComponent
                  id={data.id}
                  vote={data.isVoted}
                  count={data?.goalVotes}
                  isClub={data?.isClub}
                />
              </Box>

              {!loggedUser.device_id ? (
                data?.isClub ? (
                  <Box className="comment i">
                    <ComentBoxClub
                      count={data?.goalComments}
                      id={data?.id}
                      api={`clubs/getAllComments/${data.id}`}
                    />
                  </Box>
                ) : (
                  <Box className="comment i">
                    <ComentBox count={data?.goalComments} id={data?.id} />
                  </Box>
                )
              ) : null}
              <ShareComponent
                shareUrl={`${shareUrl.current}?share=${data.id}`}
                title={`check this out ! ${data.title}`}
                data={data}
              />
            </Box>
            <Box className="details" sx={{ flexDirection: "column" }}>
              <Box className="video-details">
                <Typography component="p">
                  {"Club:- " + data?.club}
                  <span style={{ fontWeight: "bold" }}>
                    {data.isTournament &&
                      " | " + data?.tournamentDetails?.videoCount + " videos"}
                  </span>
                </Typography>
                <Typography component="p">
                  {"City/Town:- " + data?.region}
                </Typography>
                <Typography component="p">
                  {"Uploaded by:- " +
                    data?.goalUserDetails?.firstName +
                    " " +
                    data?.goalUserDetails?.lastName}
                </Typography>
              </Box>
              <Box
                className="general-details"
                // sx={{ display: "flex", alignItems: "center" }}
              >
                <Box className="category">
                  <Typography component="p">
                    {"| " + data?.gCategory}
                  </Typography>
                </Box>
                <Box className="title">
                  <TittleComponent title={data?.title} />
                </Box>
              </Box>
            </Box>
            <Box className="createdAt">
              {moment(data.createdAt).format("MMM D, YYYY • hh:mm A")}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default GoalComponent;
